const parseBooleanEnv = (value, defaultValue) => {
  if (typeof value !== 'string') {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (!normalized) {
    return defaultValue;
  }

  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return defaultValue;
};

export const isReportDraftLocalCacheEnabled = () => (
  parseBooleanEnv(process.env.REACT_APP_REPORT_DRAFT_LOCAL_CACHE, true)
);

export const isReportDraftRemoteOnlyMode = () => !isReportDraftLocalCacheEnabled();

